/* scroll direction */
/* marquee one direction into the other. */
const SL_DIR_EASE = 0.60;
/* scroll direction */
/* scroll speed boost */
const SL_BOOST_REF = 2200;
const SL_BOOST_MAX = 3;
const SL_BOOST_DECAY = 0.5;
/* scroll speed boost */

class ScrollList extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.outer = this.querySelector(".scroll-list-outer");
    this.original = this.querySelector(".sticky_scroll_container");

    if (!this.outer || !this.original) return;

    // Speed in pixels per second
    this.speed = Number(this.dataset.speed) || 50;

    this.position = 0;
    this.lastTime = null;

    /* scroll direction */
    this.reverseOnScroll = this.dataset.reverseOnScroll === "true";
    this.direction = 1;
    this.targetDirection = 1;
    /* scroll direction */

    /* scroll speed boost */
    this.boost = 1;
    this.lastScrollTime = performance.now();
    /* scroll speed boost */

    this.setupScrollDirection();

    // Clone only once
    if (!this.querySelector(".scroll-clone")) {
      const clone = this.original.cloneNode(true);
      clone.classList.add("scroll-clone");
      this.outer.appendChild(clone);
    }

    const updateWidth = () => {
      this.width = this.original.offsetWidth;
    };

    // Calculate width
    if (document.readyState === "complete") {
      updateWidth();
      this.start();
    } else {
      window.addEventListener(
        "load",
        () => {
          updateWidth();
          this.start();
        },
        { once: true }
      );
    }

    this.resizeHandler = () => {
      updateWidth();
    };

    window.addEventListener("resize", this.resizeHandler);
  }

  /* scroll direction  */
  setupScrollDirection() {
    if (!this.reverseOnScroll) return;

    this.lastScrollY = window.scrollY;

    this.scrollHandler = () => {
      const y = window.scrollY;
      if (y === this.lastScrollY) return;

      /* scroll speed boost  */
      const now = performance.now();
      const gap = Math.max((now - this.lastScrollTime) / 1000, 0.016);
      const velocity = Math.abs(y - this.lastScrollY) / gap;
      const boost = 1 + Math.min(velocity / SL_BOOST_REF, SL_BOOST_MAX - 1);

      if (boost > this.boost) this.boost = boost;
      this.lastScrollTime = now;
      /* scroll speed boost  */

      this.targetDirection = y > this.lastScrollY ? 1 : -1;
      this.lastScrollY = y;
    };

    window.addEventListener("scroll", this.scrollHandler, { passive: true });
  }
  /* scroll direction  */

  start() {
    cancelAnimationFrame(this.raf);
    this.lastTime = null;
    this.animate();
  }

  animate(timestamp = 0) {
    if (!this.width) {
      this.raf = requestAnimationFrame(this.animate.bind(this));
      return;
    }

    if (!this.lastTime) {
      this.lastTime = timestamp;
    }

    const delta = (timestamp - this.lastTime) / 1000; // seconds
    this.lastTime = timestamp;

    /* scroll direction  */
    if (this.reverseOnScroll && this.direction !== this.targetDirection) {
      this.direction += (this.targetDirection - this.direction) * (1 - Math.exp(-delta / SL_DIR_EASE));

      if (Math.abs(this.targetDirection - this.direction) < 0.001) {
        this.direction = this.targetDirection;
      }
    }

    /* scroll speed boost  */
    if (this.boost > 1) {
      this.boost += (1 - this.boost) * (1 - Math.exp(-delta / SL_BOOST_DECAY));

      if (this.boost < 1.001) {
        this.boost = 1;
      }
    }
    /* scroll speed boost  */

    this.position -= this.speed * this.boost * delta * this.direction;

    
    this.position %= this.width;
    if (this.position > 0) {
      this.position -= this.width;
    }
    /* scroll direction  */

    this.outer.style.transform = `translate3d(${this.position}px,0,0)`;

    this.raf = requestAnimationFrame(this.animate.bind(this));
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.raf);

    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
    }

    /* scroll direction  */
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
    /* scroll direction  */
  }
}

if (!customElements.get("scroll-list")) {
  customElements.define("scroll-list", ScrollList);
}